import { z } from 'zod';

/**
 * Zod schema for the stream quality report RHF form. Keeps `Visualize` enabled when values are present.
 */
export const streamQualityReportFormSchema = z.object({
  dateRange: z.object({
    from: z.string().optional(),
    to: z.string().optional(),
    preset: z.union([
      z.string().min(1),
      z.object({
        type: z.literal('lastNHours'),
        hours: z.number().int().positive(),
      }),
    ]),
  }),
  stationsFilter: z.array(z.unknown()),
});

export type StreamQualityReportFormValues = z.infer<typeof streamQualityReportFormSchema>;
